import { useId } from 'react'
import { Box } from '@mui/material'
import { FiAlertTriangle } from 'react-icons/fi'

import CustomButton from '@/components/CustomButton'
import CustomGraphy from '@/components/CustomGraphy'
import CustomView from '@/components/CustomView'
import CloseIcon from '@mui/icons-material/Close'
import ModalMui from '@mui/material/Modal'

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: '600px',
  borderRadius: '8px',
  border: '1.5px solid #C4C4C4',
  boxShadow: 24,
  padding: '24px'
}

interface DeleteChecklistModalProps {
  open: boolean
  data: any
  onClose: () => void
  onConfirm: () => void
  loading?: boolean
  errorMessage?: string
}

export default function DeleteChecklistModal({
  open,
  data,
  onClose,
  onConfirm,
  loading = false,
  errorMessage
}: DeleteChecklistModalProps) {
  const id = useId()

  return (
    <ModalMui open={open} onClose={onClose}>
      <CustomView backColor="white" sx={style}>
        <CustomView
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          pb={1.5}
          sx={{ borderBottom: '1px solid #8f8e914d' }}
        >
          <CustomGraphy
            fontSize="22px"
            display="flex"
            alignItems="center"
            gap={1.5}
          >
            <Box
              component="span"
              display="flex"
              justifyContent="center"
              alignItems="center"
              width={46}
              height={46}
              bgcolor={'#fff0eb'}
              color={'#F64A14'}
              borderRadius={'50%'}
            >
              <FiAlertTriangle size={22} aria-hidden="true" />
            </Box>
            Excluir checklist
          </CustomGraphy>
          <CustomButton variable="default" onClick={onClose} disabled={loading}>
            <CloseIcon fontSize="large" />
          </CustomButton>
        </CustomView>

        <CustomGraphy id={`${id}-description`} mt={2.5} lineHeight={1.7}>
          Você está prestes a excluir permanentemente a checklist{' '}
          <Box component="strong">"{data?.name}"</Box>.
        </CustomGraphy>

        <CustomView
          id={`${id}-warning`}
          mt={1.5}
          p={1.75}
          style={{ backgroundColor: '#fff5f5' }}
          sx={{
            border: '1px solid #ffccc0',
            borderRadius: '6px'
          }}
        >
          <CustomGraphy fontWeight={500} style={{ color: '#f64a14' }}>
            Atenção: esta ação não pode ser desfeita.
          </CustomGraphy>
          <Box
            component="ul"
            sx={{
              m: 0,
              mt: 1,
              pl: 2,
              color: '#666766',
              fontSize: 14,
              lineHeight: 1.5,
              '& li + li': { mt: 0.5 }
            }}
          >
            <li>
              Todos os grupos, critérios e perguntas associados serão removidos.
            </li>
            <li>Histórico de uso desta checklist será perdido.</li>
            <li>Fluxos de inspeção vinculados podem ser impactados.</li>
          </Box>
        </CustomView>

        {errorMessage && (
          <CustomGraphy role="alert" as="error" mt={1.5}>
            {errorMessage}
          </CustomGraphy>
        )}

        <CustomView
          flexDirection="row"
          justifyContent="flex-end"
          gap={1.5}
          mt={5}
        >
          <CustomButton
            variable="bordered"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </CustomButton>
          <CustomButton
            variable="confirm"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Excluindo...' : 'Sim, excluir'}
          </CustomButton>
        </CustomView>
      </CustomView>
    </ModalMui>
  )
}
